import { useState, useContext, useEffect } from 'react'
import Input from '../../form/Input'
import { Link } from 'react-router-dom'
import styles from '../../form/Form.module.css'
import api from '../../../utils/api'

/* contexts */
import { Context } from '../../../context/UserContext'



function isValidCPF(cpf) {
    if (!cpf) return false;
    const cleanCPF = cpf.replace(/\D/g, '');
    // Corrigido: removida a barra invertida antes do $if (cleanCPF.length !== 11 \vert{}\vert{} /^(\d)\1{10}$/.test(cleanCPF)) return false;

    let sum = 0;
    let remainder;
    for (let i = 1; i <= 9; i++) {
        sum += parseInt(cleanCPF.substring(i - 1, i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cleanCPF.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) {
        sum += parseInt(cleanCPF.substring(i - 1, i)) * (12 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cleanCPF.substring(10, 11))) return false;

    return true;
}

function isValidEmail(email) {
    if (!email) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function Register() {
    const [user, setUser] = useState({});
    const [error, setError] = useState('');
    const [activeTerms, setActiveTerms] = useState(null);
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [showTermsModal, setShowTermsModal] = useState(false);

    const { register } = useContext(Context);

    useEffect(() => {
        async function fetchActiveTerms() {
            try {
                const response = await api.get('/term/active');
                const termsData = response.data?.terms || response.data;
                if (termsData && termsData._id) {
                    setActiveTerms(termsData);
                }
            } catch (err) {
                console.error('Erro ao carregar os termos de uso:', err);
            }
        }
        fetchActiveTerms();
    }, []);

    function handleDownloadTerms() {
        if (!activeTerms) return;
        const plainText = activeTerms.content ? activeTerms.content.replace(/<[^>]*>?/gm, '') : '';
        const blob = new Blob([plainText], { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${activeTerms.title || 'Termos_de_Uso'}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    function maskCPF(value) {
        return value
            .replace(/\D/g, '')
            .slice(0, 11)
            .replace(/(\d{3})(\d)/, '\$1.\$2')
            .replace(/(\d{3})(\d)/, '\$1.$2') .replace(/(\d{3})(\d{1,2})$/, '\$1-\$2');
    }

    function maskPhone(value) {
        return value
            .replace(/\D/g, '')
            .slice(0, 11)
            .replace(/^(\d{2})(\d)/, '(\$1) \$2')
            .replace(/(\d{1})(\d{4})(\d)/, '\$1 \$2 $3') .replace(/(\d{4})(\d{1,4})$/, '\$1 \$2');
    }

    function handleChange(e) {
        const { name, value } = e.target;

        if (name === 'document') {
            setUser({ ...user, document: maskCPF(value) });
            return;
        }

        if (name === 'phone') {
            setUser({ ...user, phone: maskPhone(value) });
            return;
        }

        setUser({ ...user, [name]: value });
    }

    function handleSubmit(e) {
        e.preventDefault();
        setError('');

        if (!isValidEmail(user.email)) {
            setError('Por favor, insira um e-mail válido.');
            return;
        }

        if (!isValidCPF(user.document)) {
            setError('Por favor, insira um CPF válido.');
            return;
        }

        if (user.password !== user.confirmpassword) {
            setError('As senhas não coincidem!');
            return;
        }

        if (!acceptedTerms) {
            setError('Você precisa aceitar os Termos de Uso para prosseguir com o cadastro.');
            return;
        }

        if (!activeTerms?._id) {
            setError('Não foi possível carregar os termos ativos no momento. Tente novamente.');
            return;
        }

        const payload = {
            ...user,
            document: user.document ? user.document.replace(/\D/g, '') : '',
            phone: user.phone ? user.phone.replace(/\D/g, '') : '',
            termsId: activeTerms._id
        };

        register(payload);
    }

    return (
        <section className={styles.form_container}>
            <h1>Cadastrar</h1>
            {error && <p className={styles.error_message}>{error}</p>}
            
            <form onSubmit={handleSubmit}>
                <Input 
                    text="Nome" 
                    type="text" 
                    name="name" 
                    placeholder="Digite o seu nome" 
                    handleOnChange={handleChange} 
                    value={user.name || ''}
                />
                
                <Input 
                    text="CPF" 
                    type="tel"
                    inputMode="numeric"
                    name="document" 
                    placeholder="000.000.000-00" 
                    handleOnChange={handleChange} 
                    value={user.document || ''}
                />
                
                <Input 
                    text="Telefone" 
                    type="tel"
                    inputMode="numeric"
                    name="phone" 
                    placeholder="Digite o seu telefone" 
                    handleOnChange={handleChange} 
                    value={user.phone || ''}
                />
                
                <Input 
                    text="E-mail" 
                    type="email" 
                    name="email" 
                    placeholder="Digite o seu e-mail" 
                    handleOnChange={handleChange} 
                    value={user.email || ''}
                />

                <Input 
                    text="Senha" 
                    type="password" 
                    name="password" 
                    placeholder="Digite a sua senha" 
                    handleOnChange={handleChange} 
                    value={user.password || ''}
                />

                <Input 
                    text="Confirmação de senha" 
                    type="password" 
                    name="confirmpassword" 
                    placeholder="Confirme a sua senha" 
                    handleOnChange={handleChange} 
                    value={user.confirmpassword || ''}
                />

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '15px 0' }}>
                    <input 
                        type="checkbox" 
                        id="acceptTerms" 
                        checked={acceptedTerms} 
                        onChange={(e) => setAcceptedTerms(e.target.checked)}
                    />
                    <label htmlFor="acceptTerms" style={{ fontSize: '0.9rem' }}>
                        Li e aceito os{' '}
                        <button 
                            type="button" 
                            onClick={() => setShowTermsModal(true)} 
                            style={{ background: 'none', border: 'none', color: '#007bff', textDecoration: 'underline', cursor: 'pointer', padding: 0 }}
                        >
                            Termos de Uso
                        </button>
                    </label>
                </div>

                <input type="submit" value="Cadastrar" />
            </form>

            <p>Já tem conta? <Link to="/login">Clique aqui</Link> para entrar!</p>

            {showTermsModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: '#fff', padding: '24px', borderRadius: '8px', maxWidth: '600px', width: '90%', maxHeight: '80vh', display: 'flex', flexDirection: 'column', position: 'relative'
                    }}>
                        <button 
                            type="button" 
                            onClick={() => setShowTermsModal(false)}
                            style={{
                                position: 'absolute', top: '12px', right: '16px', background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#666'
                            }}
                            title="Fechar"
                        >
                            ✕
                        </button>

                        <h2>{activeTerms?.title || 'Termos de Uso'}</h2>
                        
                        <div 
                            style={{ overflowY: 'auto', margin: '16px 0', padding: '12px', border: '1px solid #ddd', borderRadius: '4px', flex: 1 }}
                            dangerouslySetInnerHTML={{ __html: activeTerms?.content || '<p>Carregando termos...</p>' }}
                        />

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <button 
                                type="button" 
                                onClick={handleDownloadTerms}
                                style={{ backgroundColor: '#28a745', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}
                            >
                                Baixar Termo (.txt)
                            </button>

                            <div style={{ display: 'flex', gap: '8px' }}>
                                <button 
                                    type="button" 
                                    onClick={() => {
                                        setAcceptedTerms(true);
                                        setShowTermsModal(false);
                                    }}
                                    style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}
                                >
                                    Aceitar e Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}

export default Register;